export const responseAthenaAccountMapping = '';